export const LAYER_WIDTH = 30;
export const SCROLLBAR_MIN_WIDTH = 14;
export const SCROLLBAR_WIDTH = 10;
export const CELL_PADDING_HEIGHT = 26;
export const RESIZE_MIN_WIDTH = 20;
